// This is an opt-in view of an existing rich-text document, not a new storage
// format. Preserve every image and all writing when returning to the caller.
const REMOVED_IMAGE_MARKER='<!--workspace-picture-removed-->';
export function splitImageDocument(html = '') {
  const text=String(html || '');
  if(text.startsWith(REMOVED_IMAGE_MARKER))return {text:text.slice(REMOVED_IMAGE_MARKER.length),image:null};
  const images=[...text.matchAll(/<img\b[^>]*>/gi)].map(match=>{
    const source=match[0].match(/\bsrc\s*=\s*(?:"([^"]*)"|'([^']*)')/i);
    return {html:match[0],src:source?.[1] || source?.[2] || '',index:match.index};
  }).filter(image=>/^data:image\/png;base64,[A-Za-z0-9+/=]+$/.test(image.src));
  const image=images.find(item=>/\balt\s*=\s*["']Math Rods workspace["']/i.test(item.html)) || images[0];
  if(!image)return {text,image:null};
  const before=text.slice(0,image.index),after=text.slice(image.index+image.html.length);
  const wrapperBefore=before.match(/<p\b[^>]*>\s*$/i),wrapperAfter=after.match(/^\s*<\/p>/i);
  // Remove an image-only paragraph with the picture. Leaving that empty shell
  // behind would add another blank paragraph on every save/reopen cycle.
  const body=wrapperBefore&&wrapperAfter
    ? before.slice(0,before.length-wrapperBefore[0].length)+after.slice(wrapperAfter[0].length)
    : before+after;
  return {text:body,image:{src:image.src,html:image.html}};
}
export function joinImageDocument(text, image) {
  return image ? `<p>${image.html}</p>${text || ''}` : REMOVED_IMAGE_MARKER+String(text || '');
}
